<template>
  <Dialog
    v-model:visible="modalVisible"
    :header="modalTitle"
    :modal="true"
    :closable="true"
    :draggable="false"
    :style="{ width: '500px' }"
    :breakpoints="{ '960px': '90vw' }"
    @hide="fecharModal"
  >
    <div v-if="loading" class="flex justify-center items-center py-8">
      <ProgressSpinner style="width: 50px; height: 50px" />
    </div>

    <div v-else-if="documentos.length === 0" class="text-center py-8">
      <p class="text-gray-600 dark:text-gray-400">
        Nenhum documento disponível para este produto.
      </p>
    </div>

    <div v-else class="space-y-3">
      <div
        v-for="documento in documentos"
        :key="documento.Id"
        class="flex items-center justify-between p-3 border border-gray-200 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
      >
        <div class="flex items-center gap-3 flex-1 min-w-0">
          <i class="pi pi-file-pdf text-red-500 text-xl"></i>
          <div class="min-w-0">
            <p class="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">
              {{ documento.Descricao }}
            </p>
            <p class="text-xs text-gray-500 dark:text-gray-400">
              {{ formatDate(documento.InsertDate) }}
            </p>
          </div>
        </div>
        <button
          @click="baixarDocumento(documento)"
          class="ml-3 px-3 py-1.5 text-xs font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors flex-shrink-0"
          title="Baixar documento"
        >
          <i class="pi pi-download mr-1"></i>
          Baixar
        </button>
      </div>
    </div>

    <template #footer>
      <div class="flex justify-end gap-2">
        <button
          @click="fecharModal"
          class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors"
        >
          Fechar
        </button>
      </div>
    </template>
  </Dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Dialog from "primevue/dialog";
import ProgressSpinner from "primevue/progressspinner";

export default {
  name: "ModalDocumentosProduto",
  components: {
    Dialog,
    ProgressSpinner,
  },
  computed: {
    ...mapGetters({
      modalData: "GET_MODAL_DOCUMENTOS_PRODUTO",
      documentos: "GET_LISTA_DOCUMENTOS_PRODUTO",
    }),
    modalVisible: {
      get() {
        return this.modalData?.show || false;
      },
      set(value) {
        if (!value) {
          this.fecharModal();
        }
      },
    },
    modalTitle() {
      return this.modalData?.produtoDescricao
        ? `Documentos - ${this.modalData.produtoDescricao}`
        : "Documentos do Produto";
    },
    loading() {
      return false;
    },
  },
  methods: {
    fecharModal() {
      this.$store.commit("SET_MODAL_DOCUMENTOS_PRODUTO", {
        show: false,
        produtoId: null,
        produtoDescricao: "",
      });
      this.$store.commit("SET_LISTA_DOCUMENTOS_PRODUTO", []);
    },
    async baixarDocumento(documento) {
      try {
        const response = await this.$store.dispatch(
          "FETCH_BAIXAR_DOCUMENTO_PRODUTO",
          documento.Id
        );
        const contentType = response.headers["content-type"] || "application/octet-stream";
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", documento.FileName || `documento_${documento.Id}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$alert({
          icon: "error",
          title: "Erro",
          text: "Não foi possível baixar o documento. Tente novamente.",
        });
      }
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("pt-BR");
    },
  },
};
</script>
